// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerNetworkList from 'syft-acp-core/entities/EmployerDetail/EmployerNetworkList'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

/**
 * Lists all venues for an employer.
 *
 * @param {Object} props Properties
 * @returns {XML} ListEntities component
 */
const EmployerNetworkListView = ({ match: { params } }) => (
  <TrackingProvider
    value={{
      context: {
        employer_id: Number(params.id),
      },
    }}
  >
    <div className="page entity-list">
      <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
      <EmployerNetworkList
        employerID={Number(params.id)}
        urlBase={`/entity/employers/view/${params.id}/networks/view/`}
      />
    </div>
  </TrackingProvider>
)

EmployerNetworkListView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerNetworkListView
